import type { PermissionsResponse } from "@/interfaces/permissions";
import { apiClient } from "@/lib/apiClient";

export async function fetchPermissions(): Promise<PermissionsResponse> {
  const { data } = await apiClient.get<PermissionsResponse>("/me/permissions");
  return data;
}
